import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext({});

// Default Admin Owner User to bypass email & security key login screens for the platform owner
const ADMIN_USER = {
  id: 'openbalancer-owner-admin',
  email: 'owner@openbalancer.com',
  user_metadata: { full_name: 'Open Balancer Admin' },
  role: 'admin'
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(ADMIN_USER);
    const [loading, setLoading] = useState(false); // Default false to prevent blank screens

    useEffect(() => {
        // Asynchronously check Supabase session without blocking initial render
        try {
            supabase.auth.getSession().then(({ data }) => {
                if (data?.session?.user) {
                    setUser(data.session.user);
                }
            }).catch(err => {
                console.warn('Supabase auth session check notice:', err);
            });

            const { data } = supabase.auth.onAuthStateChange((_event, session) => {
                if (session?.user) {
                    setUser(session.user);
                }
            });

            return () => {
                if (data?.subscription) {
                    data.subscription.unsubscribe();
                }
            };
        } catch (err) {
            console.warn('Auth provider error:', err);
        }
    }, []);

    const value = {
        signUp: (data) => supabase.auth.signUp(data),
        signIn: (data) => supabase.auth.signInWithPassword(data),
        signOut: () => setUser(ADMIN_USER),
        user,
        loading: false
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
